<template>
    <b-sidebar
        v-if="isSidebarOpen"
        v-model="isSidebarOpen"
        id="sidebar-right"
        right
        backdrop
        shadow
        width="109em"
        backdrop-variant="dark"
        ref="editItem"
        no-close-on-backdrop
        no-close-on-route-change
        @change="closeSidePanelCallback()"
    >
        <template #title>
            <div>
                <strong id="sidebar-right___title__">{{ label }}</strong>
                <template v-if="!isAgent">
                    <b-button @click="exportTable('ordersTable', 'orders')" size="sm" class="ml-3 mb-1 mr-2" v-if="items.length > 0">
                        <span v-if="$mq != 'sm'">Экспорт</span>
                        <b-icon icon="cloud-download" aria-hidden="true" v-if="!isExportData"></b-icon>
                        <i class="fas fa-spinner fa-spin" v-else></i>
                    </b-button>
                    <b-button @click="toggleSummaryPanel" size="sm" class="mb-1 mr-2" v-if="items.length > 0">
                        <span v-if="$mq != 'sm'">Итоги</span>
                        <b-icon icon="list-check" aria-hidden="true" v-if="!isSummaryPanel"></b-icon>
                        <b-icon icon="list-check" aria-hidden="true" v-if="isSummaryPanel"></b-icon>
                    </b-button>
                    <b-button @click="toggleGraphPanel" size="sm" class="mb-1 mr-2" v-if="items.length > 0">
                        <span v-if="$mq != 'sm'">График</span>
                        <b-icon icon="bar-chart-line" aria-hidden="true" v-if="!isMakeGraphPanel"></b-icon>
                        <b-icon icon="bar-chart-line-fill" aria-hidden="true" v-if="isMakeGraphPanel"></b-icon>
                    </b-button>
                    <b-button @click="toggleFilterPanel" size="sm" class="mb-1 mr-2" v-if="items.length > 0">
                        <span v-if="$mq != 'sm'">Фильтр</span>
                        <b-icon icon="funnel" aria-hidden="true" v-if="!isFilterPanel"></b-icon>
                        <b-icon icon="funnel-fill" aria-hidden="true" v-if="isFilterPanel"></b-icon>
                    </b-button>
                </template>
            </div>
        </template>
        <div class="d-block">
            <template v-if="isMakeGraphPanel">
                <EasyGraphGenerator
                    :items="items"
                    :fields="fields"
                ></EasyGraphGenerator>
            </template>
            
            <template v-if="isSummaryPanel">
                <div class="summary-panel mb-3 bg-light rounded" :style="$mq == 'sm' ? 'max-width: 100%;' : 'max-width: 900px;'">
                    <div class="row">
                        <div :class="$mq == 'sm' ? 'col-12 mb-3' : 'col-md-4 col-lg-3'">
                            <b-form-select
                                v-model="selectedSummaryField"
                                :options="summaryFieldOptions"
                                class="mb-2"
                                size="sm"
                            ></b-form-select>
                        </div>
                        <div :class="$mq == 'sm' ? 'col-12' : 'col-md-8 col-lg-9'">
                            <div class="summary-results">
                                <div class="row">
                                    <div :class="$mq == 'sm' ? 'col-12 mb-3' : 'col-md-6 col-lg-5'">
                                        <table class="table table-sm mb-0">
                                            <tbody>
                                                <tr v-for="(count, value) in firstColumnResults" :key="value" class="border-bottom border-light-2">
                                                    <td class="border-0 p-0 pt-1 pr-2">{{ value }}:</td>
                                                    <td class="border-0 p-0 pt-1 text-muted text-right font-weight-bold" style="width: 40px;">{{ count }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div :class="$mq == 'sm' ? 'col-12' : 'col-md-6 col-lg-5'">
                                        <table class="table table-sm mb-0">
                                            <tbody>
                                                <tr v-for="(count, value) in secondColumnResults" :key="value" class="border-bottom border-light-2">
                                                    <td class="border-0 p-0 pt-1 pr-2">{{ value }}:</td>
                                                    <td class="border-0 p-0 pt-1 text-muted text-right font-weight-bold" style="width: 40px;">{{ count }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            
            <template v-if="isFilterPanel">
                <div class="filter-panel mb-1 bg-light rounded" :class="$mq == 'sm' ? 'p-3' : 'pr-4'">
                    <div class="row">
                        <div class="col-12">
                            <div v-for="(filter, index) in activeFilters" :key="index" class="mb-2">
                                <div :class="$mq == 'sm' ? 'd-block' : 'd-flex align-items-center'">
                                    <div :class="$mq == 'sm' ? 'col-12 mb-2' : 'col-md-4 col-lg-3'" :style="$mq == 'sm' ? '' : 'max-width: 200px;'">
                                        <b-form-select
                                            v-model="filter.field"
                                            :options="summaryFieldOptions"
                                            size="sm"
                                            :class="$mq == 'sm' ? 'w-100' : ''"
                                            @change="updateFilterValues(index)"
                                        ></b-form-select>
                                    </div>
                                    <div :class="$mq == 'sm' ? 'col-12' : 'col-md-8 col-lg-9'">
                                        <div class="d-flex flex-wrap align-items-center">
                                            <b-badge
                                                v-for="(count, value) in getFilterOptions(filter.field)"
                                                :key="value"
                                                :variant="filter.values.includes(value) ? 'success' : 'secondary'"
                                                class="mr-2 mb-1 cursor-pointer"
                                                @click="toggleFilterValue(index, value)"
                                                style="cursor: pointer;"
                                            >
                                                {{ value }} ({{ count }})
                                            </b-badge>
                                        </div>
                                    </div>
                                    <b-button 
                                        variant="link" 
                                        class="text-danger p-0 ml-2" 
                                        @click="removeFilter(index)"
                                        v-if="activeFilters.length > 1"
                                    >
                                        <b-icon icon="x-circle"></b-icon>
                                    </b-button>
                                </div>
                            </div>
                            <div class="text-center mt-2">
                                <b-button 
                                    variant="outline-secondary" 
                                    size="sm" 
                                    @click="addFilter"
                                    v-if="activeFilters.length < summaryFieldOptions.length"
                                >
                                    <b-icon icon="plus"></b-icon> Добавить фильтр
                                </b-button>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            
            <div class="position-relative">
                <div
                    v-if="items.length && items.length > 0"
                    class="position-absolute text-right small text-secondary"
                    style="right: 0px; top: -22px;"
                >Записей: {{ filteredItems.length }}{{ filteredItems.length > 9999 ? "+":"" }}</div>

                <b-table
                    id="ordersTable"
                    striped hover
                    :sticky-header="computedWindowHeight"
                    :items="filteredItems"
                    :fields="fields"
                    :busy="isTableBusy"
                    :stacked="stacked"
                    :responsive="responsive"
                >
                    <template #cell(selected)="{ rowSelected, data }">
                        <div class="text-center">
                            <template v-if="rowSelected">
                              <span class="font-size-12 font-weight-bold">&check;</span>
                            </template>
                            <template v-else>
                              <span class="font-size-12 text-muted-deep">&check;</span>
                            </template>
                        </div>
                    </template>
                    <template #cell(index)="data">
                        <div class="text-center">{{ data.index + 1 }}</div>
                    </template>
                    <template #cell(id)="data">
                        <span class="sidebar-link text-primary font-weight-bold" @click="openOrderSidebar(data.value, '')" title="Открыть заказ">
                            #{{ data.value }}
                        </span>
                    </template>
                    <template v-slot:cell(selected_services)="data">
                        <div v-if="data.item.selected_services && data.item.selected_services.length > 0">
                            <b-badge
                                v-for="(item, index) in data.item.selected_services"
                                :key="item.id"
                                variant="success"
                                class="mr-1 mb-1 cursor-pointer special-td-badge"
                                @click="openOrderSidebar(data.item.id, '', {tab: item.id})"
                                :title="`Открыть детали услуги: ${item.name}`"
                            >
                                {{ item.name }}
                            </b-badge>
                        </div>
                        <div class="text-center" v-else>—</div>
                    </template>
                    <template #cell(type.name)="data">
                        <template v-if="data.item.type">
                            <b-badge variant="secondary" class="special-td-badge">{{ data.item.type.name }}</b-badge>
                        </template>
                        <template v-else>
                            —
                        </template>
                    </template>
                    <template #cell(company.inn)="data">
                        <template v-if="data.item.company && data.item.company.inn">
                            {{ data.item.company.inn }}
                        </template>
                        <template v-else>
                            —
                        </template>
                    </template>
                    <template #cell(company_employee.lead_fio)="data">
                        <template v-if="data.item.company_employee && data.item.company_employee.lead_fio">
                            {{ data.item.company_employee.lead_fio }}
                        </template>
                        <template v-else>
                            —
                        </template>
                    </template>
                    <template #cell(company.name)="data">
                        <template v-if="data.item.company_id && !isClientAccount">
                            <span
                                class="sidebar-link font-weight-bold"
                                @click="openCompanySidebar(data.item.company_id)"
                                title="Открыть компанию"
                            >
                                {{ companyNameTdOutput(data.item, data.value) }}
                            </span>
                        </template>
                        <template v-else>
                            {{ companyNameTdOutput(data.item, data.value) }}
                        </template>
                    </template>
                    <template #cell(loading_places)="data">
                        {{ getQuotationArrayField(data.item, 'loading_places', 'Место не указано') }}
                    </template>
                    <template #cell(transport_types_id)="data">
                        <template v-if="data.item.quotations_data.length > 0">
                            {{ referencePropertyArrayGlueOutput(data.item.quotations_data[0]['transport_types_id']) }}
                        </template>
                        <template v-else>
                            —
                        </template>
                    </template>
                    <template #cell(receive_datetime)="data">
                        {{ data.value | formattedDateTime }}
                    </template>
                    <template #cell(processing_end_datetime)="data">
                        {{ data.value | formattedDateTime }}
                    </template>
                    <template #cell(created_at)="data">
                        {{ data.value | formattedDateTime }}
                    </template>
                    <template #cell(updated_at)="data">
                        {{ data.value | formattedDateTime }}
                    </template>
                    <template #cell(phone)="data">
                        {{ data.value | VMask('+#(###)###-##-##') }}
                    </template>
                    <template #cell(lead_phone)="data">
                        {{ data.value | VMask('+#(###)###-##-##') }}
                    </template>
                    <template #cell(last_comment)="data">
                        <template v-if="data.item.last_comment">
                            <div class="company-last-comment"><span v-html="data.item.last_comment.comment"></span></div>
                            <div class="text-right h5-small-text text-secondary">{{ data.item.last_comment.created_at }}</div>
                        </template>
                        <template v-else>
                            —
                        </template>
                    </template>
                    <template #cell(close_comment)="data">
                        <div class="big-table-cells"><span v-html="data.item.close_comment"></span></div>
                    </template>
                    <template #cell(status.name)="data">
                        <template v-if="data.item.status">
                            <b-badge class="special-td-badge">{{ data.item.status.name }}</b-badge>
                        </template>
                        <template v-else>
                            —
                        </template>
                    </template>
                    <template #cell(close_reason.name)="data">
                        <template v-if="data.item.close_reason">
                            <b-badge class="special-td-badge">{{ data.item.close_reason.name }}</b-badge>
                        </template>
                        <template v-else>
                            —
                        </template>
                    </template>
                    <template #cell(creator.name)="data">
                        <template v-if="data.item.creator">
                            {{ data.item.creator.name }}
                        </template>
                        <template v-else>
                            —
                        </template>
                    </template>
                    <template #cell(sales_manager)="data">
                        <template v-if="data.item.sales_manager">
                            {{ data.item.sales_manager }}
                        </template>
                        <template v-else>
                            —
                        </template>
                    </template>
                    <template #cell(source.name)="data">
                        <template v-if="data.item.source">
                            <b-badge variant="secondary" class="special-td-badge">{{ data.item.source.name }}</b-badge>
                        </template>
                        <template v-else>
                            —
                        </template>
                    </template>
                    <template #cell(selected_categories)="data">
                        <template v-if="data.item.selected_categories">
                            <div class="small-td-table"><span class="no-wrap" v-html="arrayGlueOutput(data.item.selected_categories, '<br>')"></span></div>
                        </template>
                        <template v-else>
                            —
                        </template>
                    </template>
                    <template #cell(order_service_properties_271_247)="data">
                        <template v-if="data.field.loading">
                            <template v-if="!data.value"><i class="fas fa-spinner fa-spin ml-1"></i></template>
                            <template v-else>{{ data.value }}</template>
                        </template>
                        <template v-else>
                            {{ data.value || "—" }}
                        </template>
                    </template>
                    <template #cell(order_service_properties_257)="data">
                        <template v-if="data.field.loading">
                            <template v-if="!data.value"><i class="fas fa-spinner fa-spin ml-1"></i></template>
                            <template v-else>{{ data.value }}</template>
                        </template>
                        <template v-else>
                            {{ data.value || "—" }}
                        </template>
                    </template>
                    <template #cell(order_service_properties_253_276)="data">
                        <template v-if="data.field.loading">
                            <template v-if="!data.value"><i class="fas fa-spinner fa-spin ml-1"></i></template>
                            <template v-else>{{ data.value }}</template>
                        </template>
                        <template v-else>
                            {{ data.value || "—" }}
                        </template>
                    </template>
                    <template #cell(finances_invoice)="data">
                        <template v-if="data.field.loading">
                            <template v-if="!data.value"><i class="fas fa-spinner fa-spin ml-1"></i></template>
                            <template v-else>{{ data.value }}</template>
                        </template>
                        <template v-else>
                            {{ data.value || "—" }}
                        </template>
                    </template>
                    <template #cell()="data">
                        <template v-if="data.field.loading">
                            <template v-if="!data.value"><i class="fas fa-spinner fa-spin ml-1"></i></template>
                            <template v-else>{{ data.value }}</template>
                        </template>
                        <template v-else>
                            {{ data.value || "—" }}
                        </template>
                    </template>
                    <template v-slot:table-busy>
                        <div v-for="skeletonItem in 12" :key="skeletonItem">
                            <b-skeleton type="input" height="40px" class="mb-3"></b-skeleton>
                        </div>
                    </template>
                    <template #empty="scope">
                        <p class="my-4"><em>Таблица временно пуста. Попробуйте добавить новую запись.</em></p>
                    </template>
                    <template #emptyfiltered="scope">
                        <p class="my-4"><em>По заданному фильтру ничего не найдено</em></p>
                    </template>
                </b-table>
            </div>
        </div>
    </b-sidebar>
</template>
<script>
    import { mapGetters } from 'vuex';
    import { API_GET_ORDERS_BY_IDS, API_POST_SERVICE_PROPERTIES_BY_ORDER_LIST } from "../../constants";
    import {
        defaultDataItems,
        actionShowItem,
        actionCreateOrUpdateItem,
        actionDeleteItem,
        excelExportHelpers,
        tablePrepareData
    } from '@/mixins';

    import { openOrderSidebar } from '@/mixins/openOrderSidebar';
    import { openCompanySidebar } from '@/mixins/openCompanySidebar';
    import EasyGraphGenerator from '@/components/charts/EasyGraphGenerator.vue';

    export default {
        props: {
            openOrderList: { type: Boolean, required: true },              // Need to open orderList
            orderList: { type: Array, required: true },                    // Open List
            withQuotationFields: { type: Array, required: false },         // Quotation fields
            label: {                                                       // List label for sidebar
                        type: String,
                        default: 'Список поставок/компаний',
                        required: false
                    },
            ownFields: { type: Array, required: false }, 
        },
        components: {
            EasyGraphGenerator
        },
        mixins: [
            defaultDataItems,
            actionShowItem,
            actionCreateOrUpdateItem,
            actionDeleteItem,
            excelExportHelpers,
            openOrderSidebar,
            openCompanySidebar,
            tablePrepareData
        ],
        data() {
            return {
                isTableBusy: false,
                computedWindowHeight: '',
                fields: this.getFieldsByRole(),
                items: [],
                isMakeGraphPanel: false,
                isSummaryPanel: false,
                isFilterPanel: false,
                selectedSummaryField: 'source.name',
                activeFilters: [
                    {
                        field: 'source.name',
                        values: []
                    }
                ],
                summaryFieldOptions: [
                    { value: 'company.name', text: 'Компания' },
                    { value: 'source.name', text: 'Источник поставки' },
                    { value: 'status.name', text: 'Статус' },
                    { value: 'close_reason.name', text: 'Причина закрытия' }
                ]
            }
        },
        watch: {
            orderList: {
                handler(ids) {
                    this.getDataHandler(ids)
                },
                immediate: true
            },
        },
        created() {
            window.addEventListener("resize", this.handlerHeightWindow);
        },
        destroyed() {
            window.removeEventListener("resize", this.handlerHeightWindow);
        },
        mounted() {
            this.handlerHeightWindow()
            this.ownFieldsChecker()
        },
        computed: {
            ...mapGetters("auth", ["currentUser"]),

            isAgent() {
                return this.currentUser.role.includes("agent");
            },
            isClientAccount() {
                return this.currentUser.role.includes("client");
            },
            
            // Мобильная адаптация
            stacked() {
                const stackedBreakpoints = ['sm'];
                return stackedBreakpoints.includes(this.$mq);
            },
            responsive() {
                const responsiveBreakpoints = ['md', 'lg', 'xl'];
                return responsiveBreakpoints.includes(this.$mq);
            },
            summaryResults() {
                if (!this.selectedSummaryField || !this.items.length) return {};
                
                const results = {};
                this.items.forEach(item => {
                    let value = this.getNestedValue(item, this.selectedSummaryField);
                    if (!value) {
                        value = this.selectedSummaryField === 'close_reason.name' ? 'Не закрыты' : 'Не указано';
                    }
                    results[value] = (results[value] || 0) + 1;
                });
                
                return Object.keys(results)
                    .sort((a, b) => a.localeCompare(b, 'ru'))
                    .reduce((sorted, key) => {
                        sorted[key] = results[key];
                        return sorted;
                    }, {});
            },
            firstColumnResults() {
                const results = this.summaryResults;
                const keys = Object.keys(results);
                const midPoint = Math.ceil(keys.length / 2);
                return keys.slice(0, midPoint).reduce((obj, key) => {
                    obj[key] = results[key];
                    return obj;
                }, {});
            },
            secondColumnResults() {
                const results = this.summaryResults;
                const keys = Object.keys(results);
                const midPoint = Math.ceil(keys.length / 2);
                return keys.slice(midPoint).reduce((obj, key) => {
                    obj[key] = results[key];
                    return obj;
                }, {});
            },
            filteredItems() {
                if (!this.activeFilters.length) return this.items;
                
                return this.items.filter(item => {
                    return this.activeFilters.every(filter => {
                        if (!filter.values.length) return true;
                        const value = this.getNestedValue(item, filter.field) || 
                            (filter.field === 'close_reason.name' ? 'Не закрыты' : 'Не указано');
                        return filter.values.includes(value);
                    });
                });
            },
        },
        methods: {
            getFieldsByRole() {
                // Если пользователь является агентом, используем специальный набор полей
                if (this.currentUser && this.currentUser.role && this.currentUser.role.includes("agent")) {
                    return [
                        {
                            key: 'id',
                            label: 'ID',
                            stickyColumn: true,
                            sortable: true,
                            sortDirection: 'desc',
                            visible: true
                        },
                        // {
                        //     key: 'type.name',
                        //     label: 'Тип',
                        //     sortable: true,
                        //     sortDirection: 'desc',
                        //     visible: true
                        // },
                        {
                            key: 'company.name',
                            label: 'Клиент',
                            stickyColumn: true,
                            sortable: true,
                            sortDirection: 'desc',
                            class: 'width230px text-left',
                            visible: true
                        },
                        {
                            key: 'company.inn',
                            label: 'ИНН',
                            sortable: true,
                            sortDirection: 'desc',
                            class: 'text-center',
                            visible: true
                        },
                        {
                            key: 'company_employee.lead_fio',
                            label: 'Контакт',
                            sortable: true,
                            sortDirection: 'desc',
                            class: 'width230px',
                            visible: true
                        },
                        {
                            key: 'selected_services',
                            label: 'Вид услуги',
                            sortable: true,
                            sortDirection: 'desc',
                            visible: true
                        },
                        {
                            key: 'receive_datetime',
                            label: 'Дата получения заявки',
                            sortable: true,
                            sortDirection: 'desc',
                            class: 'width140px',
                            visible: true,
                            formatter: 'formattedDateTime'
                        },
                        {
                            key: 'processing_end_datetime',
                            label: 'Дата отработки заявки',
                            sortable: true,
                            sortDirection: 'desc',
                            class: 'width140px',
                            visible: true,
                            formatter: 'formattedDateTime'
                        },
                        {
                            key: 'status.name',
                            label: 'Статус',
                            sortable: true,
                            stickyColumn: true,
                            sortDirection: 'desc',
                            visible: true,
                            class: 'text-center',
                            filterKey: 'status'
                        },
                        // {
                        //     key: 'actions',
                        //     label: 'Действия',
                        //     stickyColumn: true,
                        //     visible: true
                        // }
                    ];
                }
                
                // Стандартный набор полей для остальных ролей
                return [
                    {
                        key: 'id',
                        label: 'ID',
                        stickyColumn: true,
                        sortable: true,
                        sortDirection: 'desc',
                        visible: true,
                        'tdAttr': {
                            'data-t': 'n',
                        }
                    },
                    {
                        key: 'company.name',
                        label: 'Клиент',
                        stickyColumn: true,
                        sortable: true,
                        sortDirection: 'desc',
                        visible: true
                    },
                    {
                        key: 'order_service_properties_271_247',
                        label: 'СВХ',
                        sortable: true,
                        sortDirection: 'desc',
                        class: 'text-center',
                        loading: true,
                        whatLoad: 'order_service_properties',
                        values: [271,247],
                        visible: true
                    },
                    {
                        key: 'order_service_properties_257',
                        label: 'Номер ДТ',
                        sortable: true,
                        sortDirection: 'desc',
                        class: 'text-center',
                        loading: true,
                        whatLoad: 'order_service_properties',
                        values: [257],
                        visible: true
                    },
                    {
                        key: 'order_service_properties_253_276',
                        label: 'Номера ТС',
                        sortable: true,
                        sortDirection: 'desc',
                        class: 'text-center',
                        loading: true,
                        whatLoad: 'order_service_properties',
                        values: [253,276],
                        visible: true
                    },
                    {
                        key: 'finances_invoice',
                        label: 'Выставленные счета',
                        sortable: true,
                        sortDirection: 'desc',
                        class: 'text-center',
                        loading: true,
                        whatLoad: 'order_finance',
                        values: [],
                        visible: true
                    },
                    {
                        key: 'creator.name',
                        label: 'Менеджер поставки',
                        sortable: true,
                        sortDirection: 'desc',
                        visible: true
                    },
                    {
                        key: 'sales_manager',
                        label: 'Sales менеджер',
                        sortable: true,
                        sortDirection: 'desc',
                        visible: true
                    },                    
                    {
                        key: 'source.name',
                        label: 'Источник поставки',
                        sortable: true,
                        sortDirection: 'desc',
                        visible: true
                    },
                    {
                        key: 'selected_categories',
                        label: 'Категории',
                        sortable: true,
                        sortDirection: 'desc',
                        visible: true
                    },
                    {
                        key: 'selected_services',
                        label: 'Вид услуги',
                        sortable: true,
                        sortDirection: 'desc',
                        visible: true
                    },
                    {
                        key: 'receive_datetime',
                        label: 'Дата получения заявки',
                        sortable: true,
                        sortDirection: 'desc',
                        visible: true
                    },
                    {
                        key: 'processing_end_datetime',
                        label: 'Дата отработки заявки',
                        sortable: true,
                        sortDirection: 'desc',
                        visible: true
                    },
                    {
                        key: 'status.name',
                        label: 'Статус',
                        sortable: true,
                        sortDirection: 'desc',
                        visible: true
                    },
                    {
                        key: 'close_reason.name',
                        label: 'Причина закрытия',
                        sortable: true,
                        sortDirection: 'desc',
                        visible: true
                    },
                    {
                        key: 'close_comment',
                        label: 'Комментарий при закрытии',
                        sortable: true,
                        sortDirection: 'desc',
                        visible: true
                    },
                    {
                        key: 'updated_at',
                        label: 'Последние изменения в карточке',
                        sortable: true,
                        sortDirection: 'desc',
                        visible: true
                    }
                ];
            },
            ownFieldsChecker() {
                if (this.ownFields && this.ownFields.length > 0) {
                    this.fields = JSON.parse(JSON.stringify(this.ownFields));
                } else {
                    // Если собственные поля не заданы, используем поля в зависимости от роли
                    this.fields = this.getFieldsByRole();
                }
            },
            handlerHeightWindow() {
                let deleteHeight = 115
                this.computedWindowHeight = `${window.top.innerHeight - deleteHeight}px`
            },
            getDataHandler: async function(ids) {
                this.isTableBusy = true
                this.isSidebarOpen = true

                let finalIdsList = []

                if (ids[0].order_id) {
                    finalIdsList = ids.map((id) => {
                        return id.order_id
                    })
                } else {
                    finalIdsList = ids
                }

                let request = {
                    "order_ids": finalIdsList,
                    "with_quotation_fields": this.withQuotationFields
                }

                await api.call('post', API_GET_ORDERS_BY_IDS, request)
                    .then((response) => {
                        this.isTableBusy = false
                        this.items = response.data
                        this.prepareForUploadingDefferedData()
                    })
            },
            closeSidePanelCallback() {
                this.closeOrderList()
                this.isSidebarOpen = false
            },
            closeOrderList() {
                this.$emit("closeOrderList")
            },
            // If we have columns with loading key - load data
            prepareForUploadingDefferedData() {
                let uploadElements = {
                    'orders_list': [],
                    'uploading_items': []
                }
                // take indexes of columns for uploading data
                this.fields.forEach((item, index) => {
                    if(item.loading && item.loading==true) {
                        uploadElements['uploading_items'].push({
                            'key': item.key,
                            'index': index,
                            'whatLoad': item.whatLoad,
                            'values': item.values,
                            'items': []
                        })
                    }
                })

                // take id of elements for uploading
                this.items.forEach((dataItem, dIndex) => {
                    uploadElements['uploading_items'].forEach((uploadItem, uIndex) => {
                        dataItem[uploadItem.key] = ''
                        uploadItem.items.push({
                            index: dIndex,
                            id: dataItem.id,
                            value: []
                        })
                        uploadElements['orders_list'].push(dataItem.id)
                    })
                })

                if (uploadElements['uploading_items'].length > 0) {
                    this.uploadDefferedData(uploadElements)
                }
            },
            uploadDefferedData(uploadElements) {
                api.call("post", `${API_POST_SERVICE_PROPERTIES_BY_ORDER_LIST}`, {uploadElements: uploadElements}).then(({data}) => {
                    data.uploading_items.forEach((item, index) => {
                        item.items.forEach((order, index) => {
                            this.items[order.index][item.key] = Object.values(order.value).join(', ')
                        })
                        this.fields[item.index].loading = false
                    })
                })
            },
            companyNameTdOutput(item, value) {
                if (item.short_order && item.short_order == 1) {
                    return item.temp_name
                }
                return value
            },
            getNestedValue(obj, path) {
                return path.split('.').reduce((o, i) => o?.[i], obj);
            },
            toggleFilterPanel() {
                this.isFilterPanel = !this.isFilterPanel;
                if (this.isFilterPanel) {
                    this.isMakeGraphPanel = false;
                    this.isSummaryPanel = false;
                } else {
                    // Сбрасываем значения всех фильтров при закрытии панели
                    this.activeFilters.forEach(filter => {
                        filter.values = [];
                    });
                }
            },
            toggleGraphPanel() {
                this.isMakeGraphPanel = !this.isMakeGraphPanel;
                if (this.isMakeGraphPanel) {
                    this.isFilterPanel = false;
                }
            },
            toggleSummaryPanel() {
                this.isSummaryPanel = !this.isSummaryPanel;
                if (this.isSummaryPanel) {
                    this.isFilterPanel = false;
                }
            },
            getFilterOptions(field) {
                if (!field || !this.items.length) return {};
                
                // Получаем отфильтрованные элементы с учетом предыдущих фильтров
                const filteredItems = this.items.filter(item => {
                    const currentFilterIndex = this.activeFilters.findIndex(f => f.field === field);
                    return this.activeFilters.every((filter, index) => {
                        // Пропускаем текущий фильтр и все последующие
                        if (index >= currentFilterIndex) return true;
                        if (!filter.values.length) return true;
                        const value = this.getNestedValue(item, filter.field) || 
                            (filter.field === 'close_reason.name' ? 'Не закрыты' : 'Не указано');
                        return filter.values.includes(value);
                    });
                });
                
                const results = {};
                filteredItems.forEach(item => {
                    let value = this.getNestedValue(item, field);
                    if (!value) {
                        value = field === 'close_reason.name' ? 'Не закрыты' : 'Не указано';
                    }
                    results[value] = (results[value] || 0) + 1;
                });
                
                return Object.keys(results)
                    .sort((a, b) => a.localeCompare(b, 'ru'))
                    .reduce((sorted, key) => {
                        sorted[key] = results[key];
                        return sorted;
                    }, {});
            },
            addFilter() {
                // Находим первое неиспользованное поле
                const usedFields = this.activeFilters.map(f => f.field);
                const availableField = this.summaryFieldOptions.find(option => !usedFields.includes(option.value));
                
                if (availableField) {
                    this.activeFilters.push({
                        field: availableField.value,
                        values: []
                    });
                }
            },
            removeFilter(index) {
                this.activeFilters.splice(index, 1);
            },
            updateFilterValues(index) {
                this.activeFilters[index].values = [];
            },
            toggleFilterValue(index, value) {
                const filter = this.activeFilters[index];
                const valueIndex = filter.values.indexOf(value);
                if (valueIndex === -1) {
                    filter.values.push(value);
                } else {
                    filter.values.splice(valueIndex, 1);
                }
            },
            getQuotationArrayField(item, field, emptyText = 'Не указано') {
                if (!item.quotations_data || !item.quotations_data.length) return '';
                
                // Собираем все значения поля из всех quotations_data
                let allValues = [];
                
                item.quotations_data.forEach(quotation => {
                    if (quotation[field]) {
                        if (Array.isArray(quotation[field])) {
                            // Если поле содержит массив, добавляем все его элементы
                            allValues = allValues.concat(quotation[field]);
                        } else {
                            // Если поле содержит одиночное значение, добавляем его
                            allValues.push(quotation[field]);
                        }
                    }
                });
                
                // Убираем дубликаты и возвращаем строку
                const uniqueValues = [...new Set(allValues)];
                return uniqueValues.length > 0 ? this.referencePropertyArrayGlueOutput(uniqueValues) : emptyText;
            },
            arrayGlueOutput(array, glue) {
                if (!array || !Array.isArray(array)) return '';
                return array.join(glue);
            }
        }
    }
</script>

<style scoped>
    .border-light-2 {
        border-color: #e9ecef;
    }
</style>